export enum ServicePeriod {
    ThisMonth = "thisMonth",
    PreviousMonth = "previousMonth"
}